import React, { Component } from 'react'
import Loader from '../components/Loader'
import logo from '../assets/images/Logo_Foocus_Pos.png'
import i18n from 'i18next'
import { withTranslation } from 'react-i18next'

import ApiService from '../services/ApiService'
import { Row, Col, Card, CardBody, Alert } from "reactstrap"

class ActivateAccount extends Component {
    constructor(props) {
        super(props)
        this.state = {
          loading: true,
          activated: false,
          user: null,
          hasActiveUser: null,
          password: null,
          password_confirmation: null,
          validPassword: false
        }
    }

    componentDidMount() {
      const { uuid } = this.props.match.params
      console.log(uuid)

      ApiService.getActivationUser(uuid)
      .then(result => {
        const payload = result && result.data

        // Set the language based on user's preference
        if (payload.user && payload.user.language) {
          i18n.changeLanguage(payload.user.language)
        }

        this.setState({loading: false, user: payload.user, hasActiveUser: payload.hasActiveUser})
        console.log(payload)
      }).catch(error => {
        this.setState({loading: false})
      })
    }

    activateAccount = () => {
      console.log('activateAccount')
      const { password, password_confirmation } = this.state
      const { uuid } = this.props.match.params
      ApiService.activateUser(uuid, { password, password_confirmation })
      .then(result => {
        this.setState({activated: true})
      })
      .catch(error => {
        this.setState({activated: true})
      })
    }

    activateExistingAccount = () => {
      console.log('activateExistingAccount')
      const { uuid } = this.props.match.params
      ApiService.activateUser(uuid, {})
      .then(result => {
        this.setState({activated: true})
      })
      .catch(error => {
        this.setState({activated: true})
      })
    }

    handlePasswordChange = (e) => {
      this.setState({password: e.target.value}, this.validatePassword)
    }

    handleRepeatPasswordChange = (e) => {
      this.setState({password_confirmation: e.target.value}, this.validatePassword)
    }

    validatePassword = () => {
        const { password, password_confirmation } = this.state
        const lowerCaseLetters = /[a-z]/g;
        const upperCaseLetters = /[A-Z]/g;
        const numbers = /[0-9]/g;

        if (
          !password.match(lowerCaseLetters) ||
          !password.match(upperCaseLetters) ||
          !password.match(numbers) ||
          password.length < 8 ||
          password !== password_confirmation
        ) {
          this.setState({validPassword: false})
        } else {
          this.setState({validPassword: true})
        }
      }

    content = () => {
      const { activated, loading, user, validPassword, hasActiveUser, password, password_confirmation } = this.state
      const { t } = this.props
      console.log('hasActiveUser', hasActiveUser)

      if (loading) {
        return (<Loader />)
      }
      else if (!user) {
        return (<p>{t('activate_code_not_found')}</p>)
      }
      else if (activated) {
        return (
          <div>
            <p>{t('activate_account_activated')}</p>
            <p>{t('activate_next_step')}</p>
            <p>{t('activate_click_button')}</p>
            <a
              href="/onboarding"
              className="btn btn-primary btn-block waves-effect waves-light"
            >
              {t('activate_add_data_sources')}
            </a>

            <a
              href="https://app.foocus.ai"
              className="btn btn-primary btn-block waves-effect waves-light"
            >
              {t('activate_skip_to_dashboard')}
            </a>

          </div>
        )
      }
      else if (hasActiveUser) {
        return (
          <div>
            <p>{t('activate_existing_email')}</p>
            <p>{t('activate_existing_login')}</p>
            <div>
              <button onClick={this.activateExistingAccount} className="btn btn-primary w-md waves-effect waves-light" type="button">{t('activate_account_button')}</button>
            </div>
          </div>)
      } else {
        return (
          <div>
            <p>
              {t('activate_choose_password')}
            </p>
            <form
              className="form-horizontal mt-4"
            >
              {this.props.user && this.props.user ? (
                <Alert color="success">
                  Register User Successfully
                </Alert>
              ) : null}
              {this.props.registrationError &&
              this.props.registrationError ? (
                <Alert color="danger">
                  {this.props.registrationError}
                </Alert>
              ) : null}


              <div className="form-group">
                <label htmlFor="password">{t('activate_password')}</label>
                <input value={password ?? ''} onChange={this.handlePasswordChange} className="form-control" id="password" name="password" type="password" placeholder={t('activate_password_placeholder')} required />
              </div>
              <div className="form-group">
                <label htmlFor="password-repeat">{t('activate_repeat_password')}</label>
                <input value={password_confirmation ?? ''} onChange={this.handleRepeatPasswordChange} className="form-control" id="password-repeat" name="password-repeat" type="password" placeholder={t('activate_repeat_password_placeholder')} required />
              </div>
              <p><small>{t('activate_password_requirements')}</small></p>
              <Row className="form-group">
                <div className="col-12 text-right">
                  <button disabled={!validPassword} onClick={this.activateAccount} className="btn btn-primary w-md waves-effect waves-light" type="button">{t('activate_account_button')}</button>
                </div>
              </Row>
            </form>
          </div>
        )
      }
    }

    render() {
        const { t } = this.props
        return (
            <>
              <div className="account-pages my-5 pt-5">
                <div className="container">
                  <Row className="justify-content-center">
                    <Col md={8} lg={6} xl={5}>
                      <div className="position-relative">
                        <div className="text-center mb-5">
                            <img src={logo} height="50" alt="logo" />
                        </div>
                        <Card className="overflow-hidden">
                          <div className="bg-primary">
                            <div className="text-primary text-center p-4">
                              <h5 className="text-white font-size-20 m-0">
                                {t('activate_account_title')}
                              </h5>
                            </div>
                          </div>
                          <CardBody className="p-4">
                            <div className="p-3">
                              {this.content()}
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          © {new Date().getFullYear()} Foocus
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </>
        )
    }
}

export default withTranslation()(ActivateAccount)
